var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntervice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19L12.5 9.5",
    stroke: "#5282F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3L15.95 5.55L18.5 6.5L15.95 7.45L15 10L14.05 7.45L11.5 6.5L14.05 5.55L15 3Z",
    stroke: "#5282F0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5L5.6 4.1L7.2 4.7L5.6 5.3L5 6.9L4.4 5.3L2.8 4.7L4.4 4.1L5 2.5Z",
    stroke: "#5282F0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13L18.7 14.8L20.5 15.5L18.7 16.2L18 18L17.3 16.2L15.5 15.5L17.3 14.8L18 13Z",
    stroke: "#5282F0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntervice);
export default __webpack_public_path__ + "static/media/entervice.b3648d134ccf18842f90746a81d0f664.svg";
export { ForwardRef as ReactComponent };